import { useEffect, useState } from 'react';
import throttle from 'lodash/throttle';

export type Dimensions = {
  width: number;
  height: number;
};

export function getDimensions(): Dimensions {
  return {
    width: window.innerWidth,
    height: window.innerHeight,
  };
}

export default function useViewportDimensions(): Dimensions {
  const initialState = getDimensions();
  const [dimensions, setDimensions] = useState(initialState);

  useEffect(() => {
    const timeout = 12;

    const throttledGetDimensions = throttle(() => {
      setDimensions(getDimensions());
    }, timeout);

    window.addEventListener('resize', throttledGetDimensions);
    return () => window.removeEventListener('resize', throttledGetDimensions);
  }, []);

  return dimensions;
}
